import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useGlossary } from '../contexts/GlossaryContext';

const XSignInButton: React.FC = () => {
  const { signInWithX } = useAuth();
  const { t } = useGlossary();

  const handleSignInWithX = async () => {
    try {
      await signInWithX();
    } catch (error: any) {
      if (error.code === 'auth/popup-blocked') {
        alert(t('xsignin.popupBlocked'));
      } else if (error.code !== 'auth/popup-closed-by-user') {
        console.error('X sign-in error:', error);
        alert(t('xsignin.failed'));
      }
    }
  };

  return (
    <button
      onClick={handleSignInWithX}
      className="flex items-center gap-2 px-5 py-2.5 bg-black hover:bg-[#1DA1F2] text-white rounded-xl font-medium transition-all duration-200 border border-white/20 hover:border-white/40"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25l-7.165 8.159L3.75 2.25H0l8.105 11.78L0 21.75h3.75l6.88-7.925L18.244 21.75H24l-8.1-11.78L24 2.25h-5.756z"/>
      </svg>
      {t('xsignin.label')}
    </button>
  );
};

export default XSignInButton;
